import { useRef, useState } from 'react'
import { useAgentChatsChannel } from '@/frontend/pages/Dashboard/AgentChats/useAgentChatsChannel'
import { RevisionStream, type RevisionEdit, type RevisionPreviewData } from '@/frontend/pages/Dashboard/BusinessProcesses/revisionPreview'

const noop = () => {}

// Mounted with the server's process/version/session/turn key. No preview cache
// survives a navigation, new revision or permission revocation. Reconnect drops
// transient text; the existing Inertia poll recovers the final persisted diff.
export function useRevisionPreview(preview: RevisionPreviewData) {
  const stream = useRef(new RevisionStream())
  const [edits, setEdits] = useState<RevisionEdit[]>([])
  const reset = () => { stream.current = new RevisionStream(); setEdits([]) }
  const { connectionStatus } = useAgentChatsChannel({
    enabled: preview.state === 'streaming' && preview.live_available,
    organizationId: preview.organization_id,
    onReconnect: reset,
    onSessionUpsert: noop,
    onMessageCreated: noop,
    onMessageSubmitted: noop,
    onSubmissionFailed: noop,
    onAgentEvent: (sessionId, event) => {
      if (!preview.live_available || preview.state !== 'streaming' || sessionId !== preview.session_id) return
      if (event.turn_id !== preview.turn_id) return
      const next = stream.current.push(event, preview)
      if (next) setEdits(next)
    },
  })
  const disconnected = preview.state === 'streaming' && ['disconnected', 'rejected'].includes(connectionStatus)
  return {
    edits: preview.state === 'streaming' && !disconnected && edits.length ? edits : preview.edits,
    disconnected,
  }
}
